// 创建vuex中的store


import Vue from 'vue'
// 引入vuex
import Vuex from 'vuex'
Vue.use(Vuex);

// 准备actions,用于响应组件中的动作
const actions = {
    // login(context,value){
    //     context.commit('LOGIN',value)
    // },
    // login2(context,value){
    //     context.commit('LOGIN2',value)
    // }

}
// 准备mutations，用于操作数据（state）
const mutations = {
    // LOGIN(state,value){
    //     state.curId = 0
    // },
    // LOGIN2(state,value){
    //     state.curId = 1
    // },
    // SERVICEID(state,value){
    //     state.service_id= value
    // }
}
// 准备state用于存储数据
const state = {
   
}
// geitters用于将state中的数据进行加工
const getters = {

}


// 创建并导出store
export default new Vuex.Store({
    actions,
    mutations,
    state,
    getters
})